import React from "react";

import styles from "./ReaderModeOnlyElement.module.scss";

const ReaderModeOnlyElement = ({children}) => {
  return (
    <div className={styles["root"]}>{children}</div>
  );
};

export default ReaderModeOnlyElement;
